import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime } from 'rxjs/operators';

@UntilDestroy()
@Component({
    selector: 'cm-search',
    templateUrl: './cm-search.component.html',
    styleUrls: ['./cm-search.component.scss'],
    providers: [{ provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => CmSearchComponent) }],
    standalone: false
})
export class CmSearchComponent implements ControlValueAccessor, OnInit {
	@Input() localizationPrefix: string = 'Core/System.SearchForm';
	@Input() caseSensitive: boolean = false;
	value: string = '';
	touched = false;
	disabled = false;
	searchControl: UntypedFormControl;

	constructor() {
		this.searchControl = new UntypedFormControl(this.value);
	}

	ngOnInit(): void {
		this.searchControl.valueChanges.pipe(untilDestroyed(this), debounceTime(350)).subscribe((value: string) => {
			value = this.caseSensitive ? value : value.toLocaleLowerCase();
			this.onChange(value);
		});
	}

	onChange = (value: string): any => {};
	onTouched = () => {};

	registerOnChange(onChange: any): void {
		this.onChange = onChange;
	}

	registerOnTouched(onTouched: any): void {
		this.onTouched = onTouched;
	}

	writeValue(value: string): void {
		this.searchControl.setValue(value);
	}

	markAsTouched(): void {
		if (!this.touched) {
			this.onTouched();
			this.touched = true;
		}
	}

	setDisabledState(disabled: boolean): void {
		this.disabled = disabled;
	}

	clear() {
		this.searchControl.setValue('');
	}
}
